import { PrimitiveAtom, useSetAtom, WritableAtom } from 'jotai';
import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

const consoleWarnForAlert = (key: string, paramValue: string | null) => {
  /* only want to alert if there is a bad value */
  if (paramValue !== null) {
    // eslint-disable-next-line no-console
    console.warn(`Invalid param used for ${key}: ${paramValue}`);
  }
};

export const useSetAtomFromParams = <T>(
  atom: PrimitiveAtom<T> | WritableAtom<T, T[], void>,
  key: string,
  validValues?: readonly string[],
  isString: boolean = true,
) => {
  const [searchParams] = useSearchParams();
  const setAtom = useSetAtom(atom);

  const paramValue = searchParams.get(key);
  const isValid = validValues ? validValues.includes(paramValue!) : true;

  const defaultValue = validValues ? validValues[0] : null;
  const parsedValue = isString ? defaultValue : JSON.parse(defaultValue || '');

  useEffect(() => {
    if (isValid) {
      const value = isString ? paramValue : JSON.parse(paramValue!);
      setAtom(value as T);
    } else if (defaultValue !== null) {
      consoleWarnForAlert(key, paramValue);
      setAtom(parsedValue);
    }
  }, [paramValue]);
};
